import { IValidateTransactionRaw } from '../types'

export class ValidateTransactionMapper {
  static toDomain(data: IValidateTransactionRaw) {
    return {
      status: data.situacao,
      attendanceId: data.idAtendimento,
    }
  }
}
